/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Actions from './Actions/index'
import Address from './Address/index'
import Delete from './Delete/index'
import Edit from './Edit/index'
import Icons from './Icons/index'
import PracticeHubAccountStatus from './PracticeHubAccountStatus/index'
import React from 'react'
import Related from './Related/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Email({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Email/Emails/Content/Email"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Email.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-4PsPS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Email.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Address
  viewPath={`${viewPath}/Address`}
/>
<Icons
  viewPath={`${viewPath}/Icons`}
/>
<PracticeHubAccountStatus
  viewPath={`${viewPath}/PracticeHubAccountStatus`}
/>
</div>
<div
  data-testid="Email.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Related
  viewPath={`${viewPath}/Related`}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
</div>
<Delete
  viewPath={`${viewPath}/Delete`}
/>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
{children}
</React.Fragment>)
}